import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let SystematicApi = class SystematicApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getSqlList(params) {
        const url = this.urls.getSqlList;
        const paramsSend = {
            ...params,
        };
        const res = this.http.get({
            url,
            params: paramsSend,
        });
        return res;
    }
};
SystematicApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.SystemUrls)),
    __metadata("design:paramtypes", [Object, Object])
], SystematicApi);
export { SystematicApi };
